var InputBase = require('../base');

var AutoComplete = InputBase.extend( {
    create: function( inputOptions, $container ) {
        var self = this
          , $inp = $( '<input class="ui-widget-content" type="text">' )
                .attr('placeholder', inputOptions.placeholder)
                .appendTo( $container )
                .on( 'change', function() {
                    self.trig( 'Change' );
                } )
                .on( 'keyup', function() {
                    self.trig( 'Keyup' );
                } )
                .on( 'blur', function() {
                    self.trig( 'Blur' );
                } )
                .on( 'focus', function() {
                    self.trig( 'Focus' )
                } );

        if ( self.model.source ) {
            var sid = self.model.source.id;
            var params = self.model.source.params;
            inputOptions.source = function( request, response ) {
                if ( !request.term ) return;
                var values = Enhancer.ZContext.values(params);

                for (var i in values) {
                    if ( i.toUpperCase() === self.contextInputId.toUpperCase() ) {
                        values[i] = '%' + (values[i] + '').replace(/\%/, '') + '%';
                        break;
                    }
                }
                self.form.getSourceData( sid, {
                    params: values,
                    format: 'array',
                    paged: true,
                    page: 1,
                    rowNum: 20
                }, function( data ) {
                    items = self.standardizeData(data);
                    response( items.map(function(it) {
                        return {
                            name: it.name,
                            value: it.value,
                            label: it.displayName
                        };
                    }) );
                } );
            };
            inputOptions.select = function( event, ui ) {
                $inp.val(ui.item.value);
                return false;
            };

        } else if ( inputOptions.optSource ) {
            var values = inputOptions.optSource.split(',');

            inputOptions.source = function( request, response ) {
                if ( !request.term ) return;
                var items = [];
                for ( var i = 0; i < values.length; i++ ) {
                    if (values[i].match(request.term)) {
                        items.push(values[i].replace(/^\s|\s$/g, ''));
                    }
                }
                response( items );
            };
        } else {
            alert('No source configurated for ' + this.model.name);
        }

        $inp.autocomplete( inputOptions );

        return $inp;
    },
    //@override loadSource 
    loadSource: function(callback) {
        callback();
    }
    /*
    getValue: function() {
    },
    setValue: function( value ) {
    },
    bindCheckEvent: function( eventName ) {
        
    }*/
} );


module.exports = AutoComplete;


//////////////////
// WEBPACK FOOTER
// ./src/input-factory/autocomplete/index.js
// module id = 8
// module chunks = 0